import React, { useState, useEffect } from 'react';
import LazyImage from '../components/LazyImage';
import '../styles/Portfolio.css';

const Portfolio = () => {
  const [showAll, setShowAll] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeFilter, setActiveFilter] = useState('ALL');
  
  const categories = ["ALL", "FASHION", "LIFESTYLE", "STUDIO", "PORTRAITS"];
  
  const allImages = [
    'DSC5371_1.jpg', 'DSC5271.jpg', 'DSC5256.jpg', 'DSC5250.jpg', 'DSC4204_1.jpg',
    'DSC21711.jpg', 'DSC2106_.jpg', 'DSC1306.jpg', 'DSC1303.jpg', 'DSC1299.jpg',
    'DSC1297.jpg', 'DSC5581.jpg', 'DSC5932-ER.jpg', 'DSC7842.jpg', 'DSC7899.jpg',
    'DSC7914.jpg', 'DSC7930.jpg', 'DSC7958.jpg', 'DSC7970.jpg', 'DSC9328.jpg',
    'DSC_1125.jpg', 'DSC_1723.jpg', 'DSC_3143.jpg', 'DSC_3178.jpg', 'DSC_3196.jpg',
    'DSC_3201.jpg', 'DSC_5126.jpg', 'DSC_5352.jpg', 'DSC_5357_1.jpg', 'DSC_5367_1_1.jpg',
    'DSC_5381_1.jpg', 'DSC_5387.jpg', 'DSC_5391_1.jpg', 'DSC_5517_2.jpg', 'DSC_5525_2.jpg',
    'DSC_5540_2s.jpg', 'DSC_5541_2.jpg', 'DSC_5571_2.jpg', 'DSC_8511.jpg', 'DSC_8574.jpg',
    'DSC_8576.jpg', 'DSC_8594.jpg', 'DSC_8618.jpg', 'DSC_8638.jpg', 'DSC_8639_1.jpg',
    'DSC_8652_1.jpg', 'DSC_8653.jpg', 'DSC_8657_1.jpg', 'DSC_8683.jpg', 'DSC_8706.jpg',
    'DSC_8713.jpg', 'DSC_8733.jpg', 'DSC_9076vv.jpg', 'DSC_9081.jpg', 'DSC_9082_1.jpg',
    'DSC_9095_1.jpg', 'DSC_9127.jpg', 'DSC_9220_1.jpg', 'DSC_9228_1.jpg', 'DSC_9340.jpg',
    'DSC_9362.jpg', 'DSC_9424.jpg', 'DSC_9466.jpg', 'DSC_9503.jpg', 'DSC_9523.jpg',
    'DSC_9578.jpg', 'DSC_9625.jpg', 'DSC_9663.jpg', 'DSC_9691.jpg', 'DSC_9692.jpg',
    'DSC_9698.jpg', 'DSC_9732.jpg', 'DSC_9874.jpg', 'DSC_9876.jpg', 'DSC_9890.jpg',
    'DSC_9894.jpg', 'DSC_9895.jpg'
  ].map((filename, index) => ({
    id: index + 1,
    filename,
    url: require(`../assets/images/${filename}`),
    alt: `Portfolio ${index + 1}`
  }));

  const initialCount = 12;
  const displayedImages = showAll ? allImages : allImages.slice(0, initialCount);

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    const currentIndex = allImages.findIndex(img => img.id === selectedImage.id);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % allImages.length;
    } else {
      newIndex = (currentIndex - 1 + allImages.length) % allImages.length;
    }
    
    setSelectedImage(allImages[newIndex]);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      
      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'ArrowRight') {
        navigateImage('next');
      } else if (e.key === 'ArrowLeft') {
        navigateImage('prev');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedImage]);
  
  return (
    <section id="portfolio" className="portfolio-section">
        <div className="container">
            <div className="portfolio-header">
                <h2 className="portfolio-title">
                    PHOTOGRAPHY BY US <span className="text-brand">PORTFOLIO</span>
                </h2>
                <p className="portfolio-desc">
                    Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Pellentesque Convallis, Augue Ut Imperdiet Ultricies, Neque Lorem Eros.<br/>Pellentesque Convallis, Augue Ut Imperdiet Ultricies, Neque Lorem Eros.
                </p>
                
                <div className="filters-container">
                    {categories.map((cat, i) => (
                        <button 
                          key={i} 
                          className={`filter-btn ${activeFilter === cat ? 'active' : ''}`}
                          onClick={() => setActiveFilter(cat)}
                        >
                            {cat}
                        </button>
                    ))}
                </div>
            </div>

            <div className="portfolio-grid">
                {displayedImages.map((img, index) => (
                  <div 
                    key={img.id} 
                    className="grid-item"
                    onClick={() => openModal(img)}
                  >
                    <LazyImage src={img.url} alt={img.alt} />
                    <div className="grid-item-overlay">
                      <span className="zoom-icon">+</span>
                    </div>
                  </div>
                ))}
            </div>

            {!showAll && allImages.length > initialCount && (
              <div className="portfolio-footer">
                <button className="see-more-btn" onClick={() => setShowAll(true)}>
                  See More ({allImages.length - initialCount} MORE PHOTOS) <span className="arrow-icon">→</span>
                </button>
              </div>
            )}

            {showAll && (
              <div className="portfolio-footer">
                <button className="see-more-btn" onClick={() => setShowAll(false)}>
                  Show Less <span className="arrow-icon">↑</span>
                </button>
              </div>
            )}
        </div>

        {/* Image Modal/Lightbox */}
        {selectedImage && (
          <div className="image-modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeModal}>
                ×
              </button>
              <button 
                className="modal-nav modal-prev" 
                onClick={() => navigateImage('prev')}
                aria-label="Previous image"
              >
                ‹
              </button>
              <LazyImage src={selectedImage.url} alt={selectedImage.alt} />
              <button 
                className="modal-nav modal-next" 
                onClick={() => navigateImage('next')}
                aria-label="Next image"
              >
                ›
              </button>
              <div className="modal-caption">
                {selectedImage.id} / {allImages.length}
              </div>
            </div>
          </div>
        )}
    </section>
  );
};

export default Portfolio;
